import { BaseEntity, getCachedSolarSystemEntity, getCachedStructureEntity, isEntityOfType } from ".";
import { IGet_corporations_corporation_id_assets_200_ok } from "../service/esiclient";
import { getCachedStationEntity } from "./StationEntityCache";
import { getCachedCorpAssetEntity } from "./CorpAssetEntityCache";
import { getCachedCorporationEntity } from "./CorporationEntityCache";

export class CorpAssetEntity extends BaseEntity {
  private _corporation_id: number;
  constructor(id: number, props: any, corporation_id: number, character_id: number) {
    super(id, props);
    this._dataTypeName = "Corporation Asset";
    this._character_id = character_id;
    this._corporation_id = corporation_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_assets_200_ok> = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      entity.properties["corporation_id"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: this._corporation_id,
        numberFormat: "#00",
      };
      const corpEntity = await getCachedCorporationEntity(this._corporation_id);
      if (corpEntity !== null) {
        if (corpEntity.props.name) {
          entity.properties["corporation_name"] = {
            type: Excel.CellValueType.string,
            basicValue: corpEntity.props.name,
          };
        }
      }
      // - Id
      delete entity.properties["item_id"];
      // - Text and Image
      if (entity.properties["type"]) {
        const typeEntity = entity.properties["type"] as Excel.EntityCellValue;
        if (typeEntity && typeEntity.properties) {
          // Text
          entity.text = typeEntity.properties.name.basicValue as string;
          // Image
          if (Object.prototype.hasOwnProperty.call(typeEntity.properties, "image")) {
            entity.properties["image"] = typeEntity.properties["image"];
          }
          if (props.location_id && typeEntity.properties.group_id) {
            const groupId = typeEntity.properties.group_id.basicValue;
            if (groupId == 1657 || groupId == 1404 || groupId == 1405 || groupId == 1406) {
              const structureEntity = await getCachedStructureEntity(this._id, this._character_id);
              if (structureEntity !== null) {
                entity.text = structureEntity.props.name as string;
              }
            }
          }
        }
      }
      // - Location
      if (props.location_id && props.location_type) {
        if (props.location_type === "station") {
          // Location is a station
          const stationEntity = await getCachedStationEntity(props.location_id);
          if (stationEntity !== null) {
            entity.properties["location"] = await stationEntity.toJson(true);
            entity.properties["final_location"] = await stationEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        } else if (props.location_type === "item" && props.item_id) {
          // Location is a slot on an item (asset)
          const assetEntity = await getCachedCorpAssetEntity(props.location_id);
          if (assetEntity !== null) {
            entity.properties["location"] = await assetEntity.toJson();
            const nextAssetEntity = await getCachedCorpAssetEntity(props.location_id);
            if (nextAssetEntity != null) {
              const nextAssetIs = await nextAssetEntity.toJson();
              if (nextAssetIs.properties?.final_location) {
                if (nextAssetIs.properties?.location_type.basicValue == "solar_system") {
                  entity.properties["final_location"] = nextAssetIs;
                } else {
                  entity.properties["final_location"] = nextAssetIs.properties?.final_location;
                }
              }
            } else {
              if (assetEntity.props.location_type === "station") {
                const finalStationEntity = await getCachedStationEntity(assetEntity.props.location_id);
                if (finalStationEntity !== null) {
                  entity.properties["final_location"] = await finalStationEntity.toJson(true);
                }
              } else if (assetEntity.props.location_type == "solar_system") {
                const finalStationEntity = await getCachedStationEntity(props.location_id);
                if (finalStationEntity !== null) {
                  entity.properties["final_location"] = await finalStationEntity.toJson(true);
                } else {
                  const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
                  if (structureEntity !== null) {
                    entity.properties["final_location"] = await structureEntity.toJson(true);
                  } else {
                    entity.properties["final_location"] = await assetEntity.toJson();
                  }
                }
              } else if (assetEntity.props.location_flag == "OfficeFolder") {
                const structureEntity = await getCachedStructureEntity(
                  assetEntity.props.location_id,
                  this._character_id
                );
                if (structureEntity !== null) {
                  entity.properties["final_location"] = await structureEntity.toJson(true);
                }
              } else {
                const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
                if (structureEntity !== null) {
                  entity.properties["final_location"] = await structureEntity.toJson(true);
                } else {
                  entity.properties["final_location"] = await assetEntity.toJson();
                }
              }
            }
            delete entity.properties["location_id"];
          } else {
            const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
            if (structureEntity !== null) {
              entity.properties["location"] = await structureEntity.toJson(true);
              entity.properties["final_location"] = await structureEntity.toJson(true);
              delete entity.properties["location_id"];
            } else {
              entity.properties["location"] = {
                type: Excel.CellValueType.formattedNumber,
                basicValue: props.location_id,
                numberFormat: "##0",
              };
              entity.properties["final_location"] = {
                type: Excel.CellValueType.formattedNumber,
                basicValue: props.location_id,
                numberFormat: "##0",
              };
              delete entity.properties["location_id"];
            }
          }
        } else if (props.location_type === "solar_system" && props.location_id) {
          const solarSystemEntity = await getCachedSolarSystemEntity(props.location_id);
          if (solarSystemEntity != null) {
            entity.properties["location"] = await solarSystemEntity.toJson();
            entity.properties["final_location"] = await solarSystemEntity.toJson();
          }
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        // title: { property: "name" },
      },
    };

    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }
    return entity;
  }
}

export function isCorpAssetEntity(entity: any): boolean {
  return isEntityOfType(entity, "Corporation Asset");
}
